<template>
  <div class="heightPage"
       element-loading-text="数据加载中">
    <el-page-header @back="goBack"
                    content="个人认证"> </el-page-header>
    <el-divider></el-divider>
    <div class="myForm">
      <div class="form">
        <div class="title">个人信息</div>
        <el-form ref="companyform"
                 :model="form"
                 :rules="rules"
                 label-width="135px"
                 size="small"
                 v-enterToNext="true">

          <el-form-item label="身份证正面"
                        prop="identityCardFrontPath"
                        style="width: 100%">
            <el-upload :class="{ 'hide-upload': isHideIdCardFrontUpload }"
                       action=""
                       :limit="1"
                       accept=".jpg,.png"
                       :file-list="form.identityCardFrontPath"
                       list-type="picture-card"
                       :on-preview="onPreview"
                       :before-remove="removeUploadIdCardFront"
                       ref="uploadIdCardFont"
                       :http-request="uploadIdCardFont">
              <i class="el-icon-plus"></i>
              <div slot="tip"
                   class="el-upload__tip">
                请上传.jpg/.png格式文件，文件大小不超过10M
              </div>
            </el-upload>
          </el-form-item>

          <el-form-item label="身份证反面"
                        prop="identityCardBackPath"
                        style="width: 100%">
            <el-upload :class="{ 'hide-upload': isHideIdCardBackUpload }"
                       action=""
                       :limit="1"
                       accept=".jpg,.png"
                       :file-list="form.identityCardBackPath"
                       list-type="picture-card"
                       :on-exceed="onExceed"
                       :on-preview="onPreview"
                       ref="uploadIdCardBack"
                       :before-remove="removeUploadIdCardBack"
                       :http-request="uploadIdCardBack">
              <i class="el-icon-plus"></i>
              <div slot="tip"
                   class="el-upload__tip">
                请上传.jpg/.png格式文件，文件大小不超过10M
              </div>
            </el-upload>
          </el-form-item>

          <el-form-item label="姓名"
                        prop="cname">
            <el-input v-model="form.cname"
                      maxlength="20"
                      placeholder="请输入姓名"></el-input>
          </el-form-item>
          <el-form-item label="身份证号"
                        prop="identityCard">
            <el-input v-model="form.identityCard"
                      maxlength="18"
                      placeholder="请输入身份证号"></el-input>
          </el-form-item>
          <div style="text-align: center; margin-top: 40px">
            <el-button size="medium"
                       type="primary"
                       @click="save('companyform')">提交认证</el-button>
          </div>
        </el-form>
      </div>
      <el-dialog :visible.sync="imgDialog.show">
        <img width="100%"
             :src="imgDialog.url"
             alt="" />
      </el-dialog>
    </div>
  </div>
</template>


<script>
import IDCard from "china-id-card";
export default {
  data () {
    let validateIdcard = (rule, value, callback) => {
      //使用正则表达式进行验证手机号码
      if (IDCard(value).isVerified != true) {
        callback(new Error("身份证号码不正确"));
      } else {
        callback();
      }
    };
    return {
      submitLoading: false,
      form: {
        identityCardFrontPath: [],
        identityCardBackPath: [],
      },
      rules: {
      },
      imgDialog: {
        show: false,
        imgUrl: "",
      },
      isHideUpload: false,
      options: [],
      CompanyDetail: {},
      rules: {
        cname: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        identityCardFrontPath: [
          { required: true, message: "请上传身份证正面", trigger: "blur" },
        ],
        identityCardBackPath: [
          { required: true, message: "请上传身份证反面", trigger: "blur" },
        ],
        identityCard: [
          { required: true, message: "请输入身份证", trigger: "blur" },
          { validator: validateIdcard, trigger: "blur" },
        ],
      }
    };
  },
  computed: {
    isHideIdCardFrontUpload: function () {
      return this.form.identityCardFrontPath.length == 1;
    },
    isHideIdCardBackUpload: function () {
      return this.form.identityCardBackPath.length == 1;
    },
  },
  mounted () {
    console.log(this.$parent.$children[0]);
    this.CompanyDetail = JSON.parse(
      window.localStorage.getItem("CompanyDetail")
    );


  },
  methods: {
    removeUploadIdCardFront () {
      this.form.identityCardFrontPath = [];
    },
    removeUploadIdCardBack () {
      this.form.identityCardBackPath = [];
    }, uploadSingleImage (fileObj, imgType) {
      this.$api.upload
        .uploadSingleImage(fileObj.file)
        .then((res) => {
          this.submitLoading = false;

          if (res.code === 0) {
            this.$set(this.form[imgType], 0, {
              name: fileObj.file.name,
              url: res.data[0],
            });
            if (imgType == "identityCardFrontPath") {
              this.OcrIdCard(res.data[0], "front");
            } else if (imgType == "identityCardBackPath") {
              // this.OcrIdCard(res.data[0], "back");
            }
          }
        })
        .catch((error) => {
          this.submitLoading = false;

          if (error.response?.status == 400) {
            this.$message.warning("请上传jpg、png格式的图片");
            this.form[imgType] = [];
          }
        });
    },

    //百度识别身份证
    OcrIdCard (url, idCardSide) {
      let sendData = {
        idCardSide: idCardSide,
        httpUrl: "https:" + url,
      };
      this.$api.thirdyParty.OcrIdCard(sendData).then((res) => {
        this.submitLoading = false;
        if (res.code === 0) {
          if (idCardSide == "front") {
            this.$set(this.form, "cname", res.data.username);
            this.$set(this.form, "sex", res.data.sex);
            this.$set(this.form, "permanentResidence", res.data.address);
            this.$set(this.form, "identityCard", res.data.idcardNo);
          }
        } else if (res.code == 4) {
          this.$message.error("请上传正确的身份证");
          if (idCardSide == "front") {
            this.removeUploadIdCardFront();
          } else {
            this.removeUploadIdCardBack();
          }
        }
      });
    },
    onExceed (files, fileList) {
      this.$message.warning("只允许上传一张图片，请移除已上传图片后再进行操作");
    },
    goBack () {
      this.$router.go(-1);
    },
    onPreview (file) {
      this.imgDialog.show = true;
      this.imgDialog.url = file.url;
    },
    uploadIdCardFont (fileObj) {
      this.submitLoading = true;

      if (fileObj.file.size > 1024 * 1024 * 10) {
        this.$refs.uploadIdCardFont.clearFiles();
        this.$message.warning(
          "文件不符合规则（图片大小不超过 10M），请重新上传~"
        );
        this.submitLoading = false;

        return;
      }
      this.uploadSingleImage(fileObj, "identityCardFrontPath");
    },
    uploadIdCardBack (fileObj) {
      this.submitLoading = true;

      if (fileObj.file.size > 1024 * 1024 * 10) {
        this.$refs.uploadIdCardBack.clearFiles();
        this.$message.warning(
          "文件不符合规则（图片大小不超过 10M），请重新上传~"
        );
        this.submitLoading = false;

        return;
      }

      this.uploadSingleImage(fileObj, "identityCardBackPath");
    },
    getCompanyDetail () {
      this.$api.user.CompanyDetail().then((res) => {
        if (res.code === 0) {
          this.form = res.data;
          window.localStorage.setItem(
            "CompanyDetail",
            JSON.stringify(res.data)
          );
          this.$store.commit("change", res.data);
        }
      });
    },
    save (formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) {
          this.$message.warning("填写信息有误，请检查表单");

          return;
        }
        this.authentication();
      });
    },
    logout () {
      var lirm = localStorage.getItem("lirm");
      var lap = localStorage.getItem("lap");
      window.localStorage.clear();
      window.sessionStorage.clear();

      //如果记住密码，则留存
      if (lirm == 1) {
        localStorage.setItem("lap", lap);
      }
      this.$router.replace("/loginform");
      store.state.tabList = [];
    },
    authentication () {
      let sendData = {
        companyId: this.CompanyDetail.id,
        name: this.form.cname,
        certificate: this.form.identityCard,
        certificateFront: this.form.identityCardFrontPath[0]?.url || "",
        certificateBack: this.form.identityCardBackPath[0]?.url || ""
      }
      this.$api.user.PersonageAuthentication(sendData).then((res) => {
        if (res.code === 0) {
          this.$message.success("申请成功，将再两秒后退出登录！");
          setTimeout(() => {
            this.logout();
          }, 2000);
        }
      });
    }
  },
};
</script>
<style lang="less">
.hide-upload {
  .el-upload--picture-card {
    display: none;
  }
}
</style>
<style lang="less" scoped>
.heightPage {
  overflow: auto;
  .myForm {
    padding: 15px;
    .title {
      color: #303133;
      padding-left: 8px;
      border-left: 3px solid #409eff;
      font-size: 16px;
      text-align: left;
      margin-bottom: 20px;
    }
    .form {
      width: 30%;
      margin: 0 auto;
      margin-top: 5px;
    }
  }
}
</style>